<script lang="ts" setup>
import { ref } from 'vue'
import type { PlayerInfo } from '@/types/api/solution'

defineProps<{ players: PlayerInfo[] }>()

const colorClasses = ref(['ip', 'oop', 'opponent'])
</script>

<template>
  <table class="svgchart_legend">
    <tr
      v-for="(player, index) in players"
      :key="player?.player?.position"
    >
      <td>
        <div class="svgchart_legend_player">
          <slot name="icon_oop">
            <div
              class="svgchart_legend_player_circle"
              :class="`svgchart_legend_player_${colorClasses[index]}`"
            ></div>
          </slot>
          {{ player?.player?.position }}
          <i
            v-if="player?.player?.is_hero"
            class="mdi mdi-crown svgchart_legend_player_crown"
          ></i>
        </div>
      </td>
      <td class="svgchart_legend_player_slot">
        <slot :name="`player_${index}`" />
      </td>
    </tr>
  </table>
</template>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.svgchart {
  &_legend {
    position: absolute;
    --legend-size: 0.875rem;
    --legend-circle-size: 10px;
    --legend-item-padding: 0.075rem 0;
    --legend-inset: 1.25rem auto auto 1.875rem;
    z-index: 3;
    inset: var(--legend-inset);

    &_player {
      line-height: 1;
      font-size: var(--legend-size);
      padding: var(--legend-item-padding);
      color: var(--clr-grey-2);
      display: flex;
      align-items: center;

      &_circle {
        margin-right: 4px;
        width: var(--legend-circle-size);
        height: var(--legend-circle-size);
        border-radius: 50%;
      }

      &_crown {
        margin-left: 2px;
      }

      &_slot {
        line-height: 1;
        font-size: var(--legend-size);
        color: var(--clr-grey-2);
      }

      &_ip {
        background: var(--clr-player_ip);
      }
      &_oop {
        background: var(--clr-player_oop);
      }
      &_opponent {
        background: var(--clr-opponent);
      }
    }
  }
}
</style>
